import { Builder } from '@builder.io/react';
import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from '../BuilderComponentsName';
import { S31StateHeroSection } from '../components/interactive-sections/S31StateHero';
import { getBackgroundColorInput, getPaddingInputs } from '../utils/builderSharedInputs';
import { altBackgroundColorOptions } from '../utils/builderColorOptions';

Builder.registerComponent(S31StateHeroSection, {
    name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S31StateHero,
    friendlyName: 'S31 State Hero',
    inputs: [
        {
            name: 'description',
            type: 'longText',
            friendlyName: 'Description',
            required: true,
        },
        {
            name: 'imageSrc',
            type: 'file',
            defaultValue:
                'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F8a05c46917c04704ab7afcf6ba46968f',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'gif', 'svg'],
            friendlyName: 'Image',
            helperText: 'Upload an image or provide an image URL for the hero section',
        },
        {
            name: 'imageAltText',
            type: 'string',
            friendlyName: 'Image Alt Text',
            required: true,
            defaultValue: 'Milan Laser Clinic sitting area',
            helperText: 'Alt text for the image',
        },
        ...getBackgroundColorInput({
            defaultValue: 'Turquoise20',
            backgroundColorsList: altBackgroundColorOptions,
        }),
        ...getPaddingInputs(),
    ],
});
